'use client';

import { SvgLoader } from '@/app/elements/svg/loader';
import { classes } from '@/utils/classes/classes';

import { normalizeLabelForClass } from '@/utils/badge/normalize-label-for-class';
import { resolveTextBadge } from '@/app/components/badge/layouts/text/utils/badge-options';
import EarlyAccessImage from '@/assets/images/early-access.svg';
import './styles/@theme';

type TextBadgeProps = {
    label: string;
    rounded?: boolean;
    playerCount?: number;
};

export const TextBadge = ({ label, rounded, playerCount }: TextBadgeProps) => {
    const cssLabel = normalizeLabelForClass(label);
    if (cssLabel === 'none') {
        return null;
    }

    const { iconName, badgeCssClass, displayText, iconClassName, isEarlyAccess } = resolveTextBadge(
        cssLabel,
        label,
        playerCount
    );

    return (
        <div
            data-testid="text-badge"
            className={classes('badge', `badge--${badgeCssClass}`, rounded && 'badge--rounded')}>
            {iconName && <SvgLoader data-testid={`${iconName}-icon`} iconName={iconName} className={iconClassName} />}
            {isEarlyAccess ? (
                <img src={EarlyAccessImage.src} alt={label} className="badge-text" />
            ) : (
                <div className="badge-text">{displayText}</div>
            )}
        </div>
    );
};
